import { anodum } from '@yola/ws-sdk';

const getLastChildPath = (element) => [
  ...anodum.getTreePathOfNode(element),
  element.childNodes.length,
];

export default getLastChildPath;
